import { defineStore } from 'pinia'
import mitt from 'mitt'

export const usePlatformAuthStore = defineStore('platform-auth', {
    state: () => {
        return {
            events: mitt(),
            authRequirements: null,
            loginSuccessHandler: null,
            loginAbortHandler: null,
        }
    },
    actions: {
        setAuthRequirements(url) {
            this.authRequirements = url
        },
        setLoginSuccessHandler(handler) {
            this.loginSuccessHandler = handler
        },
        setLoginAbortHandler(handler) {
            this.loginAbortHandler = handler
        },
    },
})
